import { createStore, persist } from "easy-peasy";
import StoreModel from "./models/StoreModel";

const store = createStore(persist(StoreModel, { storage: "sessionStorage" }));

export default store;
